import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// News API
export const fetchArticles = async (category = null, publisher = null, limit = 50, offset = 0) => {
  try {
    const params = new URLSearchParams();
    
    if (category && category !== 'all') {
      params.append('category', category);
    }
    
    if (publisher && publisher !== 'all') {
      params.append('source', publisher);
    }
    
    params.append('limit', limit);
    params.append('offset', offset);
    
    const response = await axios.get(`${API}/news/?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching articles:', error);
    throw error;
  }
};

export const fetchArticleById = async (id) => {
  try {
    const response = await axios.get(`${API}/news/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching article:', error);
    throw error;
  }
};

// Categories API
export const fetchCategories = async () => {
  try {
    const response = await axios.get(`${API}/categories/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

// Publishers API
export const fetchPublishers = async () => {
  try {
    const response = await axios.get(`${API}/publishers/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching publishers:', error);
    throw error;
  }
};

// Audio API
export const fetchSummaryAudio = async (articleId) => {
  try {
    const response = await axios.get(`${API}/audio/${articleId}/summary`);
    return response.data;
  } catch (error) {
    console.error('Error fetching summary audio:', error);
    throw error;
  }
};

export const fetchFullAudio = async (articleId) => {
  try {
    const response = await axios.get(`${API}/audio/${articleId}/full`);
    return response.data;
  } catch (error) {
    console.error('Error fetching full audio:', error);
    throw error;
  }
};
